/**
 * Creates error handlers for iframe load events
 */
export const createIframeEventHandlers = (
  onLoad: () => void,
  onError: () => void,
  onLogout: () => void,
) => {
  const handleLoad = () => {
    onLoad();
  };

  const handleError = () => {
    onError();
  };

  const handleLogout = (event: MessageEvent) => {
    if (event.data?.source === 'legacy-web' && event.data?.type === 'LOGOUT') {
      onLogout();
    }
  };

  return {
    handleLoad,
    handleError,
    handleLogout,
  };
};

export const clearCookies = () => {
  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const name: string = cookie.split('=')[0].trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  });
};
